import { PHONE_MASK, INN_MASK, KPP_MASK, PHONE_PLACEHOLDER } from "@/consts";
import { useDataFormStore } from "@/stores/form";
import { limitInput } from "@/utils/handleChangeForm";
import { getNameOrganization } from "@/utils/getDataForm";
import { ref } from "vue";
import { debounce  } from "@/utils/setDebounce";
import { ADDRESS } from "@/remotes";

const nameList = ref({});
const nameDropdown = ref();

const surnameList = ref({});
const surnameDropdown = ref();

const secondNameList = ref({});
const secondNameDropdown = ref();

export default {

  setup() {

    const dataForm = useDataFormStore();
    const optionsPersonType = [
      {
        value: 1,
        label: "Юр. лицо",
      },
      {
        value: 2,
        label: "ИП/БИН",
      },
      {
        value: 0,
        label: "Физ. лицо",
      },
    ];

    const options = [
      {
        value: "Стандарт",
        label: "Стандарт",
      },
      {
        value: "Цилиндры",
        label: "Цилиндры",
      },
      {
        value: "Шины",
        label: "Шины",
      },
    ];




    async function getNameList(value) {
      if (value.length > 1) {
        try {
          const { data } = await ADDRESS.post('4_1/rs/suggest/fio', { query: value, parts: ["NAME"] });
          nameList.value = data.suggestions;

          if(nameList.value.length < 1) {
            nameList.value[0] = {disabled: "true", class: "disable-notice", value: "Нет результатов"};
          } else {
            nameList.value.unshift({disabled: "true", class: "disable-notice", value: "Выберите имя"});
          }
        } catch (e) {
          console.log(e);
        }
      }

    }

    async function getSurNameList(value) {
      if (value.length > 1) {
        try {
          const { data } = await ADDRESS.post('4_1/rs/suggest/fio', { query: value, parts: ["SURNAME"] });
          surnameList.value = data.suggestions;

          if(surnameList.value.length < 1) {
            surnameList.value[0] = {disabled: "true", class: "disable-notice", value: "Нет результатов"};
          } else {
            surnameList.value.unshift({disabled: "true", class: "disable-notice", value: "Выберите фамилию"});
          }
        } catch (e) {
          console.log(e);
        }
      }

    }

    async function getSecondNameList(value) {
      if (value.length > 1) {
        try {
          const { data } = await ADDRESS.post('4_1/rs/suggest/fio', { query: value, parts: ["PATRONYMIC"] });
          secondNameList.value = data.suggestions;

          if(secondNameList.value.length < 1) {
            secondNameList.value[0] = {disabled: "true", class: "disable-notice", value: "Нет результатов"};
          } else {
            secondNameList.value.unshift({disabled: "true", class: "disable-notice", value: "Выберите фамилию"});
          }
        } catch (e) {
          console.log(e);
        }
      }

    }
    
    let firstNametimeout = null;
    const getFirstNameSearch = (queryString, cb) => {
      
      // call callback function to return suggestions
      clearTimeout(firstNametimeout)
      firstNametimeout = setTimeout(() => {cb(Array.isArray(nameList.value) ? nameList.value : [])}, 1000)
    }

    let surNametimeout = null;
    const getSurNameSearch = (queryString, cb) => {
      
      // call callback function to return suggestions
      clearTimeout(surNametimeout)
      surNametimeout = setTimeout(() => {cb(Array.isArray(surnameList.value) ? surnameList.value : [])}, 1000)
    }

    let secondNametimeout = null;
    const getSecondNameSearch = (queryString, cb) => {
      
      // call callback function to return suggestions
      clearTimeout(secondNametimeout)
      secondNametimeout = setTimeout(() => {cb(Array.isArray(secondNameList.value) ? secondNameList.value : [])}, 1000)
    }

     // Создаем задержку запроса в 1 секунду
     const getNameDebounce = debounce(getNameList, 1000)
     const getSurNameDebounce = debounce(getSurNameList, 1000)
     const getSecondNameDebounce = debounce(getSecondNameList, 1000)


    function checkCargoPickUpFrom() {
      if  (
          dataForm.sender.officeFromEmpty
          ) 
      {
        dataForm.applicationCargoPickup.isCargoPickup = true;
      }
    }

    function checkCargoPickUpTo() {
      if  (
            dataForm.consignee.officeToEmpty
          ) 
      {
        dataForm.applicationCargoPickup.deliveryToTheAddress = true;
      }
    }

    function hanlerCityFrom() {

      checkCargoPickUpFrom();

      dataForm.updateApplicationTimeIsOver()
    }

    function hanlerCityTo() {

      checkCargoPickUpTo();
    }

    const convertToEnglish = (value) => value === "Отправитель" ? "Sender" : value === "Получатель" ? "Consignee" : value === "Третье лицо" ? "Customer" : ""

    const senderTypeChange = () => {

      // Каскадный сброс/обновление способа оплаты при смене типа отправителя
      if (convertToEnglish(dataForm.payment.whoPaysForCargoTransportation) === 'Sender') {
        const typeOfPayment = dataForm.sender.senderType ? 'Расчётный счёт юр.лица' : 'Наличные';
        dataForm.payment.typeOfPaymentForCargoTransportation = typeOfPayment;
        dataForm.payment.typeOfPaymentForCargoPickup = typeOfPayment;
        dataForm.payment.typeOfPaymentForCargoDelivery = typeOfPayment;
        dataForm.payment.typeOfPaymentForCargoExtraPacking = typeOfPayment;
      }

    }

    return {
      dataForm,
      options,
      optionsPersonType,
      PHONE_MASK,
      INN_MASK,
      KPP_MASK,
      PHONE_PLACEHOLDER,
      limitInput,
      getNameOrganization,
      hanlerCityFrom,
      hanlerCityTo,
      nameDropdown,
      nameList,
      getFirstNameSearch,
      getSurNameSearch,
      getSecondNameSearch,
      senderTypeChange,
      surnameDropdown,
      surnameList,

      secondNameDropdown,
      secondNameList,
      getName: function () {
        getNameDebounce(dataForm.sender.firstNameSender);
      },
      getSurName: function () {
        getSurNameDebounce(dataForm.sender.surnameSender);
      },
      getSecondName: function () {
        getSecondNameDebounce(dataForm.sender.secondNameSender);
      },


      checkPhone: function () {
        if (dataForm.consignee.phoneConsignee === dataForm.sender.phoneSender) {
          dataForm.sender.emailSender = dataForm.consignee.emailConsignee 
          dataForm.sender.firstNameSender = dataForm.consignee.firstNameConsignee 
          dataForm.sender.secondNameSender = dataForm.consignee.secondNameConsignee 
          dataForm.sender.surnameSender = dataForm.consignee.surnameConsignee 
          dataForm.sender.innSender = dataForm.consignee.innConsignee 
          dataForm.sender.name = dataForm.consignee.name 
        }
      },
    };
  },
};
